import React, { useCallback, useEffect, useState, useRef } from 'react'

import { apiAgent } from '../../../axiosConfig.js';
import Pagination from "../../../Pagination.js";
import LowConfidencePost from '../../feed_components/low_confidence_post.js';
import { useSelector } from "react-redux";
import ConditionalRender from "../../../ConditionalRender.js";
import { Loader } from '../../../design_system/components/Loader.jsx';
import FeedPostErrorBoundary from '../../error_handlers/FeedPostErrorBoundary.jsx';
import { indexOfObject } from '../../utils/ArrayUtils.js';
import { datepicker_input_format, dateFormator, getDateUtil } from '../../utils/dateUtils.js';
import UnmappedJobUpdatesLowConfidence from './_UnmappedJobUpdatesLowConfidence.jsx';
import LowConfidenceTypesFilter from '../../feed_components/_lowConfidenceTypes.jsx';
import MatchingArticleDateFilters from '../../admin_views/filters/ArticleBasedFilters/filters/matchingArticleDateFilters.jsx';
import { newsFeedFilterReducer as filterReducer } from '../../admin_views/filters/ProspectBasedFilters/reducer/newsFeedFilterReducer.js';
import { setState } from '../../utils/CommonReducer.js';
import Icons from '../../../design_system/components/Icons/Icons.jsx';
import SearchLensSad from "../../../assets/SearchLensSad.svg";
import { useToast } from '../../../design_system/components/Toast/ToastContext.jsx';
import Tooltip from '../../../design_system/components/ToolTip/ToolTip.jsx';
import { get_data_params } from './utils/newsFeedUtils.js';
import { IconButton } from '../../../design_system/components/Button/Button.jsx';
import { Tracker } from '../../utils/mixpanel/tracker.js';
import { buildFilterTabsAnalytics } from '../../utils/mixpanel/filterAnalytics.js';
import { confidenceTabLabel } from '../../utils/AllLabels.js';
import { canViewFeedType } from '../../../utils/access.js';
const filterTypes = [{ label: "Name Present", key: 'name_exists' }, { label: "Name + Company Present", key: 'company_exists' }];

const LowConfidenceResults = ({
    filtersState,
    filtersStateReducer,
    fetchUrl,
    displayFilterSection = true,
    confidenceType = 'low',
    trackAnalytics = false,
    allFilterTabs,
    ...props
}) => {
    const [lowConfidencePosts, setLowConfidencePosts] = useState([]);
    const [filterType, setFilterType] = useState("");
    // const [def, setDefault] = useState(true);
    const def = useRef("");
    const [totalPages, setTotalPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const current_user = useSelector(state => state.current_user?.user);
    const current_team = useSelector(state => state.current_team?.team);
    const canViewNews = canViewFeedType({ typeKey: "articles", team: current_team, user: current_user });
    const canViewJobs = canViewFeedType({ typeKey: "Job_Updates", team: current_team, user: current_user });
    const canViewSec = canViewFeedType({ typeKey: "SEC_Filings", team: current_team, user: current_user });
    const canViewMatchingResults = canViewNews || canViewSec;
    const canViewLowConfidenceJobs = canViewJobs &&
        current_team.displayable_features?.display_job_updates === true &&
        confidenceType === 'low';
    const [isFetching, setIsFetching] = useState(false);
    const hasLoadedOnce = useRef(false);
    useEffect(() => { hasLoadedOnce.current = false; }, [confidenceType]);
    const toast = useToast();
    const showInlinePagination = !canViewLowConfidenceJobs;
    const TAB_LABEL = confidenceTabLabel(confidenceType);
    const { dropDownFilterlist } = filtersState
    let { activeViewType } = dropDownFilterlist
    const setActiveViewType = (value) => {
        setDropDownFilterList({ activeViewType: value })
    }
    const setDropDownFilterList = (filterlist) => {
        filtersStateReducer({ payload: { dropDownFilterlist: { ...dropDownFilterlist, ...filterlist } }, type: 'SET_STATE' })
    }
    useEffect(() => {
        if (!canViewMatchingResults && !canViewLowConfidenceJobs) return;

        const activeTypeAllowed = activeViewType === "news_results"
            ? canViewMatchingResults
            : canViewLowConfidenceJobs;
        if (activeTypeAllowed) return;

        const nextType = canViewMatchingResults ? "news_results" : "job_updates";
        setDropDownFilterList({ activeViewType: nextType });
    }, [canViewMatchingResults, canViewLowConfidenceJobs, activeViewType]);
    useEffect(() => {
        if (canViewMatchingResults && activeViewType === "news_results") {
            fetchLowConfidencePosts(1);
        }
    }, [filterType, filtersState.filtersSelected, filtersState.dateRanges, activeViewType, canViewMatchingResults]);

    const fetchLowConfidencePosts = (page) => {
        let { filtersSelected } = filtersState;
        let temp = { dateRanges: { ...filtersState.dateRanges } }
        if (def.current != confidenceType) {
            let defaultFrom = dateFormator(getDateUtil(-14), { type: "datepicker_object" });
            let defaultTo = dateFormator(getDateUtil(), { type: "datepicker_object" });
            temp.dateRanges.created_at = { ...temp.dateRanges.created_at }
            temp.dateRanges["created_at"].value = { from: defaultFrom, to: defaultTo }
            let new_value = temp.dateRanges.created_at.value
            filtersStateReducer({
                type: "UPDATE_DATE_RANGE",
                payload: {
                    key: "created_at",
                    subkey: "value",
                    value: new_value
                }
            });
            filtersStateReducer({ type: "SET_PRESET", payload: { tab: 'created_at', preset: { label: "Custom range", key: "custom", value: new_value }, value: new_value } });
            def.current = confidenceType;
            return;
        }
        setIsFetching(true);
        const startTime = performance.now();
        var params = get_data_params(confidenceType, { filtersState: filtersState })
        params[filterType] = true
        params.page = page
        if (current_team.displayable_features.display_mid_confidence) params.feed_article_condition = confidenceType
        setState(filtersStateReducer)({ data_params: params, loaders: { filtersSubmitLoader: true } })
        apiAgent({
            method: 'get',
            url: fetchUrl,
            params: params
        }).then(
            (response) => {
                setIsFetching(false);
                hasLoadedOnce.current = true;
                let result = response.data;
                let low_posts = result.data.map(d => {
                    if (d.post_type !== 'Post::SecFiling' && d.mentioned_for) {
                        if (!d.matching_article_tags) d.matching_article_tags = {};
                        d.matching_article_tags[d.mentioned_for] = d.mentioned_for;
                        d.categories.map((c) => d.matching_article_tags[c] = c)
                    }
                    return d;
                })
                filtersStateReducer({ type: "ASSIGN_AGGREGATES_DATA", payload: { aggregates: result.aggregates } })
                setLowConfidencePosts(low_posts);
                setTotalPages(result.total_pages);
                setCurrentPage(result.page || page);
                props.parentReducer({
                    payload: {
                        high_confidence_results_count: response.data.high_confidence_results_count,
                        mid_confidence_results_count: response.data.mid_confidence_results_count,
                        low_confidence_results_count: response.data.low_confidence_results_count,
                        allFilterTabs: response.data.all_filter_tabs
                    },
                    type: 'SET_STATE'
                })
                if (trackAnalytics && filtersState.appliedFiltersCount > 0) {
                    const analytics = buildFilterTabsAnalytics(filtersState, response.data.all_filter_tabs || allFilterTabs)
                    Tracker.track("Newsfeed Filter Applied Successfully", { page, results_count: result.total, response_time_ms: Math.round(performance.now() - startTime), tab: TAB_LABEL, ...analytics });
                }
            },
            (error) => {
                if (trackAnalytics) {
                    const analytics = buildFilterTabsAnalytics(filtersState, allFilterTabs);
                    Tracker.track("Newsfeed Load Error", { page, error_message: error.response?.data?.error || error.message || "Something went wrong", response_time_ms: Math.round(performance.now() - startTime), tab: TAB_LABEL, filters_active: filtersState.appliedFiltersCount > 0, ...analytics });
                }
                setIsFetching(false);
            }
        );
    }
    const onPublishCallback = useCallback((published_article) => {
        let ind = indexOfObject(lowConfidencePosts, "id", published_article.id);
        if (ind === -1) return;
        let temp = [...lowConfidencePosts];
        temp.splice(ind, 1);
        setLowConfidencePosts(temp)
        toast.success("News article moved to high confidence")
    }, [lowConfidencePosts])
    const renderNewsResults = () => {
        return (
            <>
                {
                    !isFetching && (lowConfidencePosts.length === 0) && (
                        <div className="text-center newsfeed__empty-state">
                            <img src={SearchLensSad} className="newsfeed__search-empty-img" alt="No results" />
                            <div className="body-m-semibold newsfeed__empty-state-title">No <span className="newsfeed__confidence-type">{confidenceType}</span> Confidence results to show</div>
                        </div>
                    )
                }
                <ConditionalRender if={!showInlinePagination}>
                    <div>
                        {!isFetching && (totalPages !== 0) && (
                            <Pagination variant="bounded" totalPages={totalPages}
                                currentPage={currentPage}
                                onPageChange={fetchLowConfidencePosts}
                                style={{ padding: '0 8px' }}
                            />)
                        }
                    </div>
                </ConditionalRender>
                {isFetching && (<div className="newsfeed__loader-center"><Loader Size="Large" isLoading={true} /></div>)}
                <div>
                    {!isFetching && lowConfidencePosts.map(item => (
                        <FeedPostErrorBoundary key={item.id}>
                            <LowConfidencePost item={item} callbacks={{ onPublishCallback: onPublishCallback }} confidenceType={confidenceType} />
                        </FeedPostErrorBoundary>
                    ))}
                </div>
                <div className="newsfeed__pagination-bottom">
                    {!isFetching && (totalPages !== 0) && (
                        <Pagination variant="bounded" totalPages={totalPages}
                            currentPage={currentPage}
                            onPageChange={fetchLowConfidencePosts}
                        />)
                    }
                </div>
            </>
        )
    }
    const renderJobUpdates = () => {
        return <UnmappedJobUpdatesLowConfidence
            type="feed"
            buttonLabel='Move to High Confidence'
            setParentComponentState={(count_data) => props.parentReducer({ type: "SET_STATE", payload: { low_confidence_results_count: count_data.unmappedCount } })}
            dropDownFilterlist={dropDownFilterlist}
            dateRanges={filtersState.dateRanges}
        />
    }
    return (
        <React.Fragment>
            <div className="newsfeed__low-conf-wrapper">
                {!hasLoadedOnce.current && isFetching ?
                    <div className="newsfeed__loader-center newsfeed__loader-center--full-height">
                        <Loader Size="Large" isLoading={true} customStyle={{ margin: '50px auto' }} />
                    </div>
                    :
                    <>
                <ConditionalRender if={displayFilterSection}>
                    <div className={`flex items-center newsfeed__feed-filter-row ${showInlinePagination ? 'newsfeed__feed-filter-row--relative' : 'justify-between'}`}>
                        <ConditionalRender if={canViewMatchingResults && canViewLowConfidenceJobs}>
                            <LowConfidenceTypesFilter activeType={activeViewType} setActiveType={setActiveViewType} />
                        </ConditionalRender>
                        <ConditionalRender if={showInlinePagination && !isFetching && totalPages !== 0}>
                            <div className="newsfeed__inline-pagination">
                                <Pagination variant="bounded" totalPages={totalPages} currentPage={currentPage} onPageChange={fetchLowConfidencePosts} />
                            </div>
                        </ConditionalRender>
                        <ConditionalRender if={!showInlinePagination && canViewLowConfidenceJobs}>
                            <div></div>
                        </ConditionalRender>
                        <div className='flex items-center gap-m'>
                            <MatchingArticleDateFilters
                                filtersState={filtersState}
                                filtersStateReducer={filtersStateReducer}
                                tempFilterReducer={filterReducer}
                                trackAnalytics={trackAnalytics}
                                tab={TAB_LABEL}
                                customStyle={{ position: "relative", width: 32, height: 32 }}
                                innerText=''
                                position={canViewLowConfidenceJobs ? 'left' : 'right'}
                                theme="GREEN"
                                popUpWidth={500}
                                initialTab={"created_at"}
                            />
                            <ConditionalRender if={current_team.low_conf_filter_enabled}>
                                <Tooltip
                                    tooltipText="Filters"
                                    placement="bottom-end"
                                    showWithoutOverflowing
                                >
                                    <IconButton
                                        Size="Small"
                                        Type="Tertiary"
                                        IconName="filter-sliders"
                                        onClick={() => { filtersStateReducer({ type: "SET_POPUP", payload: { showable: true } }) }}
                                        IsSelected={filtersState.appliedFiltersCount > 0}
                                    />
                                </Tooltip>
                            </ConditionalRender>
                        </div>
                    </div>
                </ConditionalRender>
                {canViewMatchingResults && activeViewType === "news_results" && renderNewsResults()}
                {canViewLowConfidenceJobs && activeViewType === "job_updates" && renderJobUpdates()}
                </>
                }
            </div>
        </React.Fragment>
    );
}

export default LowConfidenceResults;
